module.exports = __webpack_public_path__ + "img/yellow-tick.fde91bfd.svg";